import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';
import { black } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';

export const CountryPickerLink = styled.button`
  border: none;
  background: none;
  display: flex;
  align-items: center;
  ${fontBody(16)};
  padding: 0;
  cursor: pointer;

  ${breakpoint('large')} {
    ${fontBody(14)};
    gap: 8px;
  }
`;

export const Name = styled.p`
  margin: 0;
  color: ${black};
`;
